@if (breadcrumbsList.length) {
    <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
            @for (item of breadcrumbsList; track item; let i = $index; let isLast = $last) {
                <li [class.is-active]="isLast ? true : false" [ngClass]="{ 'is-underline is-secondary': !isLast }">
                    @if (!isLast) {
                        <a (click)="goToPage($event, i)" aria-current="page" href="{{ item.url }}">
                            {{ item.label }}
                        </a>
                    }
                    @if (isLast) {
                        <a aria-current="page" [attr.aria-current]="true">{{ item.label }}</a>
                    }
                </li>
            }
        </ul>
    </nav>
}
@if (html) {
    <div [innerHTML]="html"></div>
}
